import { makeAutoObservable } from "mobx";

export class AppStore {
    showSignIn = false;
    constructor() {
        makeAutoObservable(this);
    }

    setShowSignIn(show: boolean) {
        this.showSignIn = show;
    }
}
